
import { CartUpdateEvent } from '@theme/events';

if (!window.skuppUpsellsInitialized) {
  window.skuppUpsellsInitialized = true;

  document.addEventListener('change', (event) => {
    const select = event.target.closest(
      'select[data-skupp-upsell-variant]'
    );

    if (!select) return;

    const card = select.closest('[data-skupp-upsell-card]');
    const price = card?.querySelector('[data-skupp-upsell-price]');
    const option = select.selectedOptions[0];

    if (price && option?.dataset.price) {
      price.textContent = option.dataset.price;
    }
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-skupp-upsell-add]');

    if (!button) return;

    const card = button.closest('[data-skupp-upsell-card]');
    const variantInput = card?.querySelector(
      '[data-skupp-upsell-variant]'
    );
    const errorElement = card?.querySelector(
      '[data-skupp-upsell-error]'
    );

    if (!variantInput?.value) return;

    const cartItems = document.querySelectorAll(
      'cart-items-component[data-section-id]'
    );

    const sections = [
      ...new Set(
        [...cartItems]
          .map((element) => element.dataset.sectionId)
          .filter(Boolean)
      ),
    ];

    if (!sections.length) return;

    button.disabled = true;
    button.textContent = 'AÑADIENDO...';

    if (errorElement) {
      errorElement.hidden = true;
      errorElement.textContent = '';
    }

    try {
      const response = await fetch(
        `${window.Shopify?.routes?.root || '/'}cart/add.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantInput.value),
                quantity: 1,
              },
            ],
            sections,
            sections_url: window.location.pathname,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok || data.status >= 400) {
        throw new Error(
          data.description || data.message || 'No se pudo añadir.'
        );
      }

      const cartResponse = await fetch(
        `${window.Shopify?.routes?.root || '/'}cart.js`
      );

      if (!cartResponse.ok) {
        throw new Error('No se pudo actualizar el carrito.');
      }

      const cart = await cartResponse.json();

      document.dispatchEvent(
        new CartUpdateEvent(cart, sections[0], {
          itemCount: cart.item_count,
          source: 'skupp-upsells',
          sections: data.sections || {},
        })
      );

    } catch (error) {
      console.error('SKUPP Upsells:', error);

      if (errorElement?.isConnected) {
        errorElement.textContent =
          error.message || 'Error al añadir el producto.';
        errorElement.hidden = false;
      }
    } finally {
      if (button.isConnected) {
        button.disabled = false;
        button.textContent = '+ AÑADIR';
      }
    }
  });
}
